import { render, staticRenderFns } from "./snap04.vue?vue&type=template&id=ddd7a28e"
import script from "./snap04.vue?vue&type=script&lang=js"
export * from "./snap04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports